import { render, staticRenderFns } from "./cart-payment.vue?vue&type=template&id=56fb1e18&"
import script from "./cart-payment.vue?vue&type=script&lang=js&"
export * from "./cart-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports